<template>
  <b-modal
    :active="value"
    has-modal-card
    trap-focus
    :can-cancel="['escape', 'outside']"
    @close="requestClose"
  >
    <div class="modal-card" style="width: 70vw; max-width: 98vw;">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('load_takeoff') }}</p>
        <button type="button" class="delete" @click="requestClose" />
      </header>
      <section class="modal-card-body">
        <import-entities-optimized
          :can-overwrite="false"
          :project-id="Number(projectId)"
          entity-type="takeoff"
          @busy="onImporterBusy"
          @success="onImporterSuccess"
        />
      </section>
    </div>
  </b-modal>
</template>

<script>
import ImportEntitiesOptimized from '../import-entities-optimized.vue'

export default {
  name: 'boq-import-takeoff-modal',

  components: {
    ImportEntitiesOptimized,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: [Number, String],
      required: true,
    },
  },

  data: () => ({
    importerBusy: false,
  }),

  methods: {
    onImporterBusy(busy) {
      this.importerBusy = !!busy
    },

    requestClose() {
      if (this.importerBusy) {
        this.$buefy.dialog.alert({
          title: this.$t('import_in_progress'),
          message: this.$t('wait_until_import_finishes'),
          type: 'is-warning',
          hasIcon: true,
          confirmText: this.$t('accept'),
        })
        return
      }

      this.$emit('input', false)
    },

    onImporterSuccess() {
      this.importerBusy = false
      this.$emit('success')
      this.$emit('input', false)
    },
  },
}
</script>
